export const statusObj = {
    '신규견적': { title: '신규견적', color: 'primary' },
    '견적완료': { title: '견적완료', color: 'secondary' },
    '미발주': { title: '미발주', color: 'success' },
    '신규주문': { title: '신규주문', color: 'warning' },
    '주문완료': { title: '주문완료', color: 'success' },
    '신고관리': { title: '신고관리', color: 'info' },
    '배송완료': { title: '배송완료', color: 'success' },
    '주문취소': { title: '주문취소', color: 'error' },
    '취소완료': { title: '취소완료', color: 'error' },
}
